export const environment = {
   production: true,
   appEnv: 'swbeta',
   wsurl: 'wss://platform.musaffa.com/ws',
   resendPinSeconds: 5,
   wsFundamentalsUrl: 'wss://platform.musaffa.com/fundamentalsa',
   // apiUrl: "https://api.musaffa.us",
   // apiUrl: "http://localhost:8000",
   // apiUrl: 'https://musaffa-api-plaid.swbeta.in',
   apiUrl: 'https://musaffa-api.swbeta.in',
   tradingUrl: 'https://musaffa-api.swbeta.in',
   tradingPlatformUrl: 'https://trade.musaffa.us',
   // apiUrl: 'https://api.musaffa.us',
   // tradingUrl: 'https://api.musaffa.us',
   //  apiUrl: "https://2247-2401-4900-1c20-28f4-506e-3e65-a3c5-34.ngrok-free.app",
   //  apiUrl: "http://localhost:8004",
   // serviceCallToken: "uLw0E3kRnZi8XhUcB4mP7sGqY2o5VtdsdFjL9aWrDbX1fC6eHpS3oJg5TuQxMvNzRyI",
   websiteUrl: 'https://musaffa.swbeta.in',
   authUrl: 'https://musaffa-auth.swbeta.in',
   isUat: true,
   serviceCallToken: "H0LyS25lQoL6sdaRhBvTtKeU3Vgs4N2Pfm1D9wcJaFZzCnlGy6diAru4ROhbEopVEXk",
   branchKey: 'key_test_gwoJg2hTupXbtF9yMIW0mddlsEg1FA9V',
   moengageAppId: '5LPG8R1V97324XX5IZL4O9WX',
   moengageDebugLogs: 1,
   oldServerApiUrl: 'https://platform.musaffa.com',
   compliance_history: 'https://novaapi.musaffa.us',
   compliance_history2: 'https://novaapi.musaffa.us',
   useOldEtfDisclaimer: false,
   featurebase: {
      appId: '67417a4dcf8f1febf04f2191',
   },
   revenueCat: {
      v1: {
         url: 'https://api.revenuecat.com/v1',
         apiKey: 'sk_neecazHLjPDpYLDocwwMbXxPYUtSw',
      },
   },
   stripe: {
      monthly: 'MONTHLY',
      yearly: 'YEARLY',
      manageBillingLink: 'https://billing.stripe.com/p/login/test_bIYeXr9IKa0L0GQ6oo' // TEST
      // manageBillingLink: 'https://billing.stripe.com/p/login/8wMcPNfbH0ZTgso8ww' // LIVE
   },
   firebase: {
      //  apiKey: "AIzaSyCyc6DFHzb0H8CUbPKb-rvICDnnjhf4kf4",
      apiKey: "AIzaSyBBjsDoglbqjTWdMUY5pYT6VhuJdaqM0S0",
      authDomain: "test-musaffa.firebaseapp.com",
      projectId: "test-musaffa",
      storageBucket: "test-musaffa.appspot.com",
      messagingSenderId: "721243036223",
      appId: "1:721243036223:web:7da43865267fc873e4f68a",
      measurementId: "G-P0MY7BWYP5"
   }
   ,
   investment_checklist_new: {
      api_base_url: 'https://novaapi.musaffa.us/api/'
   },
   // typeSense: {
   //    url: 'https://h3ques1ic9vt6z4rp-1.a1.typesense.net',
   //    searchApiKey: 'NHAYhtkThbpAtxpBemD4AKPc9loguxqT',
   // },
   // typeSense: {
   //    url: 'https://kn2smbywvz1li8hrp-1.a1.typesense.net',
   //    searchApiKey: 'bgUgo63f47A7TriwuS3OMgENTaJcv8SF',
   // },

   copyrightapi: 'https://angular.infomanav.in'
   ,
   typeSenseV1: {
      url: 'https://kn2smbywvz1li8hrp-1.a1.typesense.net',
      searchApiKey: 'bgUgo63f47A7TriwuS3OMgENTaJcv8SF',
   },
   typeSense: {
      // url: 'https://h3ques1ic9vt6z4rp-1.a1.typesense.net',
      // searchApiKey: 'NHAYhtkThbpAtxpBemD4AKPc9loguxqT',
      url: 'https://kn2smbywvz1li8hrp-1.a1.typesense.net',
      searchApiKey: 'bgUgo63f47A7TriwuS3OMgENTaJcv8SF',
   },


   chartCollection: {
      url: 'https://h3ques1ic9vt6z4rp-1.a1.typesense.net',
      searchApiKey: 'OXawCsQAIfFaxEvCyIf5obN25vXJe9MR'
   },
   typeSenseFinancial: {
      url: 'https://h3ques1ic9vt6z4rp-1.a1.typesense.net',
      searchApiKey: 'NHAYhtkThbpAtxpBemD4AKPc9loguxqT',

      // url:'https://kn2smbywvz1li8hrp-1.a1.typesense.net',
      // searchApiKey:'bgUgo63f47A7TriwuS3OMgENTaJcv8SF'
   }
   ,
   statementCollection: {
      url: 'https://typesense.infomanav.in',
      searchApiKey: 'WwQySUDzbI3tNEozoarFJM9dsKFbeaXjNFKROidedC4ZFjD5',
   },

   nove_infomavan_v2: {
      url: 'https://typesense.infomanav.in',
      searchApiKey: 'v0R3WozafhWeECu5MVuKr6HPcXI0hLPh',
   },

   new_statement_data: {
      url: 'https://typesense.infomanav.in',
      searchApiKey: 'v0R3WozafhWeECu5MVuKr6HPcXI0hLPh',
   },
   ipo_data: {
      url: 'https://uattypesense.infomanav.in',
      searchApiKey: 'eHgM3zEZaflcTRxNAsPmlF4Aac5ahfewzJ3x79eHI2YL8ynk',
   },
   uatTypeSense: {
      // url: 'https://h3ques1ic9vt6z4rp-1.a1.typesense.net',
      // searchApiKey: 'NHAYhtkThbpAtxpBemD4AKPc9loguxqT',

      url: 'https://kn2smbywvz1li8hrp-1.a1.typesense.net',
      searchApiKey: 'bgUgo63f47A7TriwuS3OMgENTaJcv8SF'
   },
   firebaseCloudFunctionsUrl:
      'https://us-central1-musaffa-website.cloudfunctions.net',
   registrationBaseUrl: 'https://platform.musaffa.com',
   purificationApiUrl: 'https://platform.musaffa.com',
   mixPlaneID: '1e6e166d0f07967bf6dc540935591af9',
   defaultRemoteConfig: {
      free_collections: JSON.stringify({ "stocks": ["ORAS.CA", "PHGC.CA", "MODON.AD", "TALABAT", "ADNOCGAS.AD", "IHC.AD", "U.U", "RY.TO", "TRI.TO", "BREN.JK", "TPIA.JK", "AMMN.JK", "RIT1.TA", "SLARL.TA", "MNRT.TA", "SMT.L", "SGRO.L", "BDEV.L", "BHI.BC", "ECOPETROL.BC", "NUTRESA.BC", "ENELAM.SN", "LTM.SN", "COPEC.SN", "241560.KS", "900140.KS", "005930.KS", "AAPL", "NVDA", "MSFT", "ABSP.JO", "NPN.JO", "GRT.JO", "2222.SR", "1120.SR", "2082.SR", "2330.TW", "2317.TW", "2454.TW", "ICT.PM", "FGEN.PM", "OGP.PM", "GMEXICOB.MX", "GRUMAB.MX", "VISTAA.MX", "EQNR.OL", "AKRBP.OL", "MOWI.OL", "RUAL.ME", "FLOT.ME", "ENPG.ME", "1299.HK", "700.HK", "981.HK", "MAREL.IC", "SVN.IC", "BRIM.IC", "NOVO B.CO", "NSIS B.CO", "MAERSK B.CO", "ETI.NL", "DANGCEM.NL", "BUAFOODS.NL", "EQT.ST", "HEXA B.ST", "EVO.ST", "THYAO.E.IS", "TAVHL.E.IS", "QNBFB.E.IS", "MC.PA", "RMS.PA", "OR.PA", "SAP.DE", "SIE.DE", "DTE.DE", "601398.SS", "600519.SS", "601288.SS", "ASML.AS", "PRX.AS", "INGA.AS", "ROG.SW", "NESN.SW", "NOVN.SW", "7203.T", "6269.T", "8306.T", "RELIANCE.NS", "TCS.NS", "HDFCBANK.NS", "BHP.AX", "RIO.AX", "CBA.AX", "ITX.MC", "IBE.MC", "SAN.MC", "RACE.MI", "ENEL.MI", "ISP.MI", "ABI.BR", "UCB.BR", "ARGX.BR", "D05.SI", "O39.SI", "U11.SI", "PETR4.SA", "ITUB4.SA", "VALE3.SA", "WABERERS.BD", "MASTERPLAST.BD", "APPENINN.BD", "BANPU.BK", "DELTA.BK", "PTT.BK", "QNBK.QA", "IQCD.QA", "QIBK.QA", "KFH.KW", "NBK.KW", "BOUBYAN.KW", "NDA FI.HE", "KNEBV.HE", "NOKIA.HE", "MAYBANK.KL", "PBBANK.KL", "CIMB.KL", "EBS.VI", "VER.VI", "OMV.VI", "CEZ.PR", "KOMB.PR", "GEV.PR", "RYA.IR", "KRZ.IR", "KRX.IR", "VCB.VN", "BID.VN", "FPT.VN", "PKO.WA", "PKN.WA", "SPL.WA", "YPFD.BA", "GGAL.BA", "TECO2.BA", "EDP.LS", "GALP.LS", "JMT.LS", "FPH.NZ", "MEL.NZ", "AIA.NZ", "ATW.CS", "IAM.CS", "BCP.CS", "EUROB.AT", "ETE.AT", "HTO.AT", "PIV.A.CR", "BVCC.CR", "BPV.CR", "ALBH.BH", "NBB.BH", "BBK.BH", "COMI.CA", "SWDY.CA", "TMGH.CA", "BATBC.DS", "ROBI.DS", "RENATA.DS", "IGN1L.VS", "TEL1L.VS", "SAB1L.VS", "LHV1T.TL", "INF1T.TL", "EGR1T.TL", "GZE1R.RG", "BAL1R.RG", "VIRSI.RG", "PACE", "MFL", "ALAC"], "etfs": ["SPY", "VOO", "IVV", "539313.BO", "539312.BO", "538057.BO", "SWDA.L", "XDNY.DE", "VUSD.L", "EXX7.DE", "EL44.DE", "EXW1.DE", "ZSP.TO", "XIU.TO", "XIC.TO", "IBTF", "AAA", "ADFI"] }),
      verification_defaults: JSON.stringify({
         "mobile_verification": {
            "enabled": true,
            "disabled_countries": [
               "AE",
               "XK",
               "AD",
               "AF",
               "AG",
               "AI",
               "AL",
               "AM",
               "AO",
               "AZ",
               "BD",
               "BF",
               "BG",
               "BI",
               "BQ",
               "BR",
               "BY",
               "CD",
               "CF",
               "CG",
               "CI",
               "CM",
               "CV",
               "CW",
               "DJ",
               "DM",
               "DO",
               "DZ",
               "EG",
               "ET",
               "GA",
               "GE",
               "GF",
               "GM",
               "GN",
               "GQ",
               "GT",
               "GW",
               "HK",
               "HN",
               "ID",
               "IE",
               "IL",
               "IQ",
               "IR",
               "IT",
               "JM",
               "JO",
               "KE",
               "KG",
               "KH",
               "KM",
               "KN",
               "KP",
               "KR",
               "KZ",
               "LB",
               "LK",
               "LR",
               "LY",
               "MA",
               "MG",
               "MK",
               "MO",
               "MR",
               "MW",
               "MY",
               "MZ",
               "NA",
               "NE",
               "NG",
               "NP",
               "OM",
               "PA",
               "PE",
               "PH",
               "PK",
               "PS",
               "QA",
               "RE",
               "RU",
               "RW",
               "SD",
               "SI",
               "SL",
               "SO",
               "SS",
               "ST",
               "SV",
               "SY",
               "TD",
               "TG",
               "TJ",
               "TL",
               "TN",
               "TZ",
               "UZ",
               "VN",
               "YE",
               "YT",
               "ZM",
               "ZW",
               "MM",
               "UA"
            ],
            "update_mandatory": false,
            "update_message": {
               "title": "Mobile Number Update",
               "description": "Currently, you can skip updating your mobile number. However, in the future, it will be a required field. Please consider updating your number for better service and account security."
            }
         }
      }),
      request_report_updation_defaults: JSON.stringify({
         daily_requests_allowed: 3,
         updation_requested_label:
            'You have requested for the report updation of this stock. Our Financial Analyst team are reviewing the stocks and you’ll get an email notification as soon as the report updation is completed.',
         limit_reached_label: {
            title: 'Daily updation request limit reached!',
            description:
               'We have currently kept a limit of 3 report updation requests per day so as to get back to as many users as possible. Inshallah you can come back tomorrow and request for more.',
         },
         process_explanation: {
            title: 'Stock Updation Request Process',
            body: '- As soon as you request for covering some stock, our analysts add them within their pipeline to try and cover the stock within 48 hours.\n- The analyst then screen the stock for their: Business activities, Interest bearing securities and assets and Interest bearing debt.\n- Once the analyst completes their analysis, the stock is sent for 1 more level of review from our senior analyst.\n- The stock is then termed as Halal, Not Halal or Doubtful.\n- We then notify you that your requested stock is now covered. \n\nIf you like our work and what we are doing, do help us by rating 5 stars on Google/Apple store.',
         },
         country_durations: [
            {
               country_code: 'GB',
               duration: 200,
            },
            {
               country_code: 'SG',
               duration: 200,
            },
            {
               country_code: 'FR',
               duration: 200,
            },
            {
               country_code: 'AU',
               duration: 200,
            },
            {
               country_code: 'DEFAULT',
               duration: 120,
            },
         ],
         status: [
            {
               key: 'pending',
               display_value: 'Pending',
               description: 'Pending',
            },
            {
               key: 'updated',
               display_value: 'Published',
               description:
                  'Compliance report updated as per the latest financial reports',
            },
            {
               key: 'already_uptodate',
               display_value: 'Already Up-to-date',
               description:
                  'New financial reports are not published by the company yet',
            },
            {
               key: 'not_applicable',
               display_value: 'Not Applicable',
               description: 'Updating the reports was not possible',
               status_reasons: [
                  {
                     key: 'acquired',
                     display_value: 'Acquired',
                     description: 'Company was acquired by a different entity',
                  },
                  {
                     key: 'merged',
                     display_value: 'Merged',
                     description: 'Company was merged with a different entity',
                  },
                  {
                     key: 'ceased',
                     display_value: 'Ceased',
                     description: 'Company ceased to exist',
                  },
                  {
                     key: 'bankrupt',
                     display_value: 'Bankrupt',
                     description:
                        'Company got bankrupt and no longer trades on the exchange market',
                  },
                  {
                     key: 'delisted',
                     display_value: 'Delisted',
                     description:
                        'Company got delisted and no longer trades on the exchange market',
                  },
                  {
                     key: 'suspended',
                     display_value: 'Suspended',
                     description: 'Company is suspended',
                  },
                  {
                     key: 'private_company',
                     display_value: 'Private Company',
                     description:
                        'Company is private and no longer trades on the exchange market ',
                  },
                  {
                     key: 'closed_end_trust',
                     display_value: 'Closed End Trust',
                     description: 'The entity is a closed end trust',
                  },
               ],
            },
         ],
      }),
      config_defaults: JSON.stringify({
         monthly_free_stock_count: 5,
         show_etf_compliance_breakdown: false,
         active_promotional_offer: 'three_months_free_1st_Sep',
         signup_banner_title: 'Sign up Now',
         signup_banner_text: 'Get access to premium features!',
         signup_banner_freemium_title: 'Upgrade Now',
         signup_banner_freemium_text:
            'Upgrade to get access to premium features',
         profile_anonymous_signup_title: 'Signup for Musaffa',
         profile_anonymous_signup_cta: 'Get Started',
         profile_anonymous_signup_subtitle:
            'Create a free account and get premium access!',
         profile_freemium_signup_subtitle:
            'Upgrade to Premium plan to have unlimited access to compliance statuses of over 30,000 stocks and ETFs globally',
         profile_freemium_signup_cta: 'Go Premium',
         web_header_cta: 'Upgrade Now',
         web_desktop_anonymous_banner_text:
            'We are giving out 3-months of Premium for free!',
         web_desktop_anonymous_banner_link_text: 'Click to claim this offer',
         web_desktop_freemium_banner_text:
            'We are giving out 3-months of Premium for free!',
         web_desktop_freemium_banner_link_text: 'Click to claim this offer',
         investment_check_list_enabled: false,
         forecast_enabled: false,
         feedback_form_link: 'https://tally.so/r/wArG7l',
         investment_check_list_enabled_v2: true,
         forecast_enabled_v2: true,
         login_bottomsheet: {
            skipped_title: 'Unlock Shariah Compliance Status For Free?',
            skipped_description:
               'Signing up will unlock the Shariah Compliance Status of more than 30,000 covered stocks across the Globe!',
         },
         fixed_income_etf_text: {
            title: 'Fixed Income Etf',
            description:
               "The inherent guarantee of returns in fixed-income ETFs is considered non-compliant with Shariah's emphasis on shared profit and risk.",
         },
         compliance_score_text: {
            title: 'Musaffa Halal Score',
            stock_description:
               'Musaffa Halal Rating is a proprietary ranking metric that compares all stocks in a given country from lowest to highest Shariah compliance standing.\nThe higher the star rating, the greater the adherence to Shariah regulations, resulting in a reduced requirement to purify Haram income following the sale of these stock holdings.',
            etf_description:
               'Musaffa Halal Rating is a proprietary ranking metric that compares all ETFs in a given country from lowest to highest Shariah compliance standing.',
         },
         purification_limit_text: {
            title: 'Purification trial',
            description:
               'Purification trial is restricted to 1 per day. Musaffa Premium gives you unlimited purification calculations.',
         },
         cba_status_disclaimer:
            'Few holdings of this ETF may be classified as Non-compliant as per Musaffa’s screening methodology, but the overal ETF is Halal based on the Core Business Activity screening used in ETF screening which is approved by our Shariah advisors.',

         show_fb_login: false,
         analyst_rating_disclaimer:
            "The analyst recommendations (Buy/Sell/Hold etc) are not given by Musaffa. We don't encourage our users to buy Non Compliant stocks. These ratings are given by the independent analysts from stock rating firms across the globe.",
         analyst_rating_detailed_disclaimer:
            "The analyst recommendations (Buy/Sell/Hold etc) are not given by Musaffa. We don't encourage our users to buy Non Compliant stocks. These ratings are given by the independent analysts from stock rating firms across the globe.",
         price_delay_defaults: {
            "stock_message": "Pricing for {{COUNTRY_CODE}} stocks is delayed by {{DURATION}}",
            "etf_message": "Pricing for {{COUNTRY_CODE}} stocks is delayed by {{DURATION}}",
            "country_delays": [
               {
                  "country_code": "US",
                  "stock_price_delay": "24 hours",
                  "etf_price_delay": "24 hours"
               },
               {
                  "country_code": "SG",
                  "stock_price_delay": "24 hours",
                  "etf_price_delay": "24 hours"
               },
               {
                  "country_code": "SA",
                  "stock_price_delay": "24 hours",
                  "etf_price_delay": "24 hours"
               },
               {
                  "country_code": "CA",
                  "stock_price_delay": "24 hours",
                  "etf_price_delay": "24 hours"
               },
               {
                  "country_code": "AE",
                  "stock_price_delay": "24 hours",
                  "etf_price_delay": "24 hours"
               },
               {
                  "country_code": "ES",
                  "stock_price_delay": "24 hours",
                  "etf_price_delay": "24 hours"
               },
               {
                  "country_code": "EG",
                  "stock_price_delay": "24 hours",
                  "etf_price_delay": "24 hours"
               },
               {
                  "country_code": "FR",
                  "stock_price_delay": "24 hours",
                  "etf_price_delay": "24 hours"
               },
               {
                  "country_code": "ID",
                  "stock_price_delay": "24 hours",
                  "etf_price_delay": "24 hours"
               },
               {
                  "country_code": "GB",
                  "stock_price_delay": "24 hours",
                  "etf_price_delay": "24 hours"
               },
               {
                  "country_code": "NL",
                  "stock_price_delay": "24 hours",
                  "etf_price_delay": "24 hours"
               },
               {
                  "country_code": "MY",
                  "stock_price_delay": "24 hours",
                  "etf_price_delay": "24 hours"
               },
               {
                  "country_code": "IN",
                  "stock_price_delay": "24 hours",
                  "etf_price_delay": "24 hours"
               },
               {
                  "country_code": "QA",
                  "stock_price_delay": "24 hours",
                  "etf_price_delay": "24 hours"
               }
            ]
         },
         mobile_support: {
            "title": "Enable Personalized Assistance?",
            "description": "We appreciate your trust by subscribing to our paid plan.To ensure smooth assistance and personalized guidance, please add your mobile number below.",
            "dismissable": false
         }
      }),
      user_onboarding_defaults: JSON.stringify({
         brokerages: [
            'Alpaca',
            'Alpaca Paper',
            'Bux',
            'CommSec',
            'DEGIRO',
            'ETrade',
            'Fidelity',
            'Questrade',
            'Robinhood',
            'Schwab',
            'Stake UK',
            'Stake Australia',
            'TD Ameritrade',
            'Trading212',
            'Upstox',
            'Vanguard US',
            'Wealthsimple Trade',
            'Webull US',
            'Webull Canada',
            'Zerodha',
         ],
         countries: [
            { country: 'United States', countryCode: 'US' },
            { country: 'Australia', countryCode: 'AU' },
            { country: 'Bahrain', countryCode: 'BH' },
            { country: 'Bangladesh', countryCode: 'BD' },
            { country: 'Canada', countryCode: 'CA' },
            { country: 'Egypt', countryCode: 'EG' },
            { country: 'France', countryCode: 'FR' },
            { country: 'Germany', countryCode: 'DE' },
            { country: 'India', countryCode: 'IN' },
            { country: 'Indonesia', countryCode: 'ID' },
            { country: 'Malaysia', countryCode: 'MY' },
            { country: 'Netherlands', countryCode: 'NL' },
            { country: 'Qatar', countryCode: 'QA' },
            { country: 'Saudi Arabia', countryCode: 'SA' },
            { country: 'Singapore', countryCode: 'SG' },
            { country: 'Spain', countryCode: 'ES' },
            { country: 'Turkey', countryCode: 'TR' },
            { country: 'United Arab Emirates', countryCode: 'AE' },
            { country: 'United Kingdom', countryCode: 'GB' },
         ],
         onboarding_qna: [
            {
               type: 'interested_markets',
               selection_type: 'multi_select_dropdown',
               show_other: true,
               question: 'Which markets are you interested in screening?',
               options: [
                  { display_value: 'United States', key: 'US' },
                  { display_value: 'Australia', key: 'AU' },
                  { display_value: 'Bahrain', key: 'BH' },
                  { display_value: 'Bangladesh', key: 'BD' },
                  { display_value: 'Canada', key: 'CA' },
                  { display_value: 'Egypt', key: 'EG' },
                  { display_value: 'France', key: 'FR' },
                  { display_value: 'Germany', key: 'DE' },
                  { display_value: 'India', key: 'IN' },
                  { display_value: 'Indonesia', key: 'ID' },
                  { display_value: 'Malaysia', key: 'MY' },
                  { display_value: 'Netherlands', key: 'NL' },
                  { display_value: 'Qatar', key: 'QA' },
                  { display_value: 'Saudi Arabia', key: 'SA' },
                  { display_value: 'Singapore', key: 'SG' },
                  { display_value: 'Spain', key: 'ES' },
                  { display_value: 'Turkey', key: 'TR' },
                  { display_value: 'United Arab Emirates', key: 'AE' },
                  { display_value: 'United Kingdom', key: 'GB' },
               ],
            },
            {
               type: 'brokerages',
               selection_type: 'multi_select_dropdown',
               show_other: true,
               question: 'Which brokerages do you use currently?',
               options: [
                  { key: 'Alpaca', display_value: 'Alpaca' },
                  { key: 'Alpaca Paper', display_value: 'Alpaca Paper' },
                  { key: 'Bux', display_value: 'Bux' },
                  { key: 'CommSec', display_value: 'CommSec' },
                  { key: 'DEGIRO', display_value: 'DEGIRO' },
                  { key: 'ETrade', display_value: 'E*Trade' },
                  { key: 'Fidelity', display_value: 'Fidelity' },
                  { key: 'Questrade', display_value: 'Questrade' },
                  { key: 'Robinhood', display_value: 'Robinhood' },
                  { key: 'Schwab', display_value: 'Schwab' },
                  { key: 'Stake UK', display_value: 'Stake UK' },
                  { key: 'Stake Australia', display_value: 'Stake Australia' },
                  { key: 'TD Ameritrade', display_value: 'TD Ameritrade' },
                  { key: 'Trading212', display_value: 'Trading212' },
                  { key: 'Upstox', display_value: 'Upstox' },
                  { key: 'Vanguard US', display_value: 'Vanguard US' },
                  {
                     key: 'Wealthsimple Trade',
                     display_value: 'Wealthsimple Trade',
                  },
                  { key: 'Webull US', display_value: 'Webull US' },
                  { key: 'Webull Canada', display_value: 'Webull Canada' },
                  { key: 'Zerodha', display_value: 'Zerodha' },
               ],
            },
            {
               type: 'user_description',
               selection_type: 'single_select_dropdown',
               show_other: false,
               question: 'Which of the following describes you best?',
               options: [
                  { key: 'Learner', display_value: 'Learner' },
                  { key: 'Beginner', display_value: 'Beginner' },
                  { key: 'Intermediate', display_value: 'Intermediate' },
                  { key: 'Advanced', display_value: 'Advanced' },
                  { key: 'Manager', display_value: 'Manager}' },
               ],
            },
            {
               type: 'investor_type',
               selection_type: 'radio',
               show_other: false,
               question: 'What type of an investor are you?',
               options: [
                  { key: 'Active Investor', display_value: 'Active Investor' },
                  {
                     key: 'Passive Investor',
                     display_value: 'Passive Investor',
                  },
               ],
            },
            {
               type: 'signup_reason',
               selection_type: 'multi_select_dropdown',
               show_other: true,
               question: 'Why did you sign up for Musaffa?',
               options: [
                  {
                     key: 'To find Halal investment opportunities',
                     display_value: 'To find Halal investment opportunities',
                  },
                  {
                     key: 'To learn about the stock market',
                     display_value: 'To learn about the stock market',
                  },
                  {
                     key: 'To learn about Islamic Finance',
                     display_value: 'To learn about Islamic Finance',
                  },
                  {
                     key: 'To track my portfolio for Shariah compliance',
                     display_value:
                        'To track my portfolio for Shariah compliance',
                  },
               ],
            },
            {
               type: 'first_point_attribution',
               selection_type: 'single_select_dropdown',
               show_other: false,
               question: 'Where did you hear about Musaffa?',
               options: [
                  { key: 'facebook', display_value: 'Facebook' },
                  { key: 'twitter', display_value: 'Twitter' },
                  { key: 'linkedin', display_value: 'LinkedIn' },
                  { key: 'youtube', display_value: 'Youtube' },
                  { key: 'instagram', display_value: 'Instagram' },
                  { key: 'reddit', display_value: 'Reddit' },
                  { key: 'website', display_value: 'Website' },
                  { key: 'friends', display_value: 'Friends' },
                  { key: 'other', display_value: 'Other (Please Specify)' },
               ],
            },
         ],
         onboarding_skip_config: {
            "show_skip_onboarding_qna": false,
            "show_skip_onboarding_watchlist": true
         }
      }),
      //   promo_offers_config: JSON.stringify([{"id":1,"name":"three_months_free_1st_Sep","duration_free_days":90,"free_text":"3-months free","button_cta":"Claim without credit card","start_date":"2022-09-01"}]),
      promo_offers_config: JSON.stringify([
         {
            title: 'Pre-Ramadan Offer',
            description: 'Only {{END_DATE_DAYS}} left!',
            offer_highlight_number: '70',
            offer_highlight_text: '% Off!',
            end_date: '2024-03-10',
            stripe_coupon_id: 'uUtj3Ici',
            show_offer: false,
         },
      ]),

      subscription_plans_config: JSON.stringify(
         {
            plans: [
               {
                  plan_identifier: 'free',
                  plan_name: 'Free',
                  plan_description: 'Explore Musaffa',
                  featured_items: [
                     { name: 'Halal Status', icon: 'green_tick' },
                     {
                        name: '1 Sample Detailed Shariah Report',
                        icon: 'orange_tick',
                     },
                     {
                        name: '1 Sample Shariah Compliance History',
                        icon: 'orange_tick',
                     },
                     {
                        name: '1 Sample ESG (ISRI) Reports (Coming Soon)',
                        icon: 'orange_tick',
                     },
                     { name: 'Daily Stock Coverage Requests', icon: 'cross' },
                     { name: 'Basic Compliance Alerts', icon: 'green_tick' },
                     {
                        name: 'Screener with basic filters',
                        icon: 'green_tick',
                     },
                     {
                        name: '1 Watchlist (10 symbols per watchlist)',
                        icon: 'green_tick',
                     },
                     {
                        name: 'Basic Halal Stock Collections',
                        icon: 'green_tick',
                     },
                     { name: 'Super Investors Portfolio', icon: 'cross' },
                     { name: 'Investment Checklist & Forecast', icon: 'cross' },
                     { name: 'Brokerage Connected Portfolios', icon: 'cross' },
                     { name: '1 Manual Portfolio', icon: 'green_tick' },
                     {
                        name: 'Basic Portfolio Compliance Tracker',
                        icon: 'green_tick',
                     },
                     { name: 'Portfolio Purification Tracker', icon: 'cross' },
                     { name: 'Brokerage Connected Trading', icon: 'cross' },
                     { name: 'Zakat Calculator', icon: 'green_tick' },
                     {
                        name: 'Beginner guides on halal investing and stock fundamental tutorials (coming soon)',
                        icon: 'green_tick',
                     },
                     { name: 'Email Support', icon: 'green_tick' },
                  ],
                  all_identifiers: [],
                  level: 0,
               },
               {
                  plan_identifier: 'starter',
                  plan_name: 'Musaffa Starter',
                  plan_description: 'Screener Basic',
                  level: 1,
                  all_identifiers: ['starter_monthly', 'starter_yearly'],
                  featured_items: [
                     {
                        name: 'Halal Status & Musaffa Star Rating',
                        icon: 'green_tick',
                     },
                     {
                        name: '50 Detailed Shariah Reports',
                        icon: 'green_tick',
                     },
                     {
                        name: '50 Shariah Compliance History',
                        icon: 'green_tick',
                     },
                     {
                        name: '50 Detailed ESG (ISRI) Reports',
                        icon: 'green_tick',
                     },
                     {
                        name: '3 Daily Stock Coverage Requests',
                        icon: 'green_tick',
                     },
                     { name: 'Basic Compliance Alerts', icon: 'green_tick' },
                     {
                        name: 'Screener with intermediate filters',
                        icon: 'green_tick',
                     },
                     {
                        name: '5 Watchlist (25 symbols per watchlist)',
                        icon: 'green_tick',
                     },
                     { name: 'Halal Stock Collections', icon: 'green_tick' },
                     { name: 'Super Investors Portfolio', icon: 'green_tick' },
                     { name: 'Investment Checklist & Forecast', icon: 'cross' },
                     { name: 'Brokerage Connected Portfolios', icon: 'cross' },
                     { name: '3 Manual Portfolio', icon: 'green_tick' },
                     {
                        name: 'Basic Portfolio Compliance Tracker',
                        icon: 'green_tick',
                     },
                     { name: 'Portfolio Purification Tracker', icon: 'cross' },
                     { name: 'Brokerage Connected Trading', icon: 'cross' },
                     { name: 'Zakat Calculator', icon: 'green_tick' },
                     {
                        name: 'Intermediate guides on halal investing, beginner courses and quizzes, and pre-recorded webinars with experts (coming soon)',
                        icon: 'green_tick',
                     },
                     { name: 'Email & In-App Support', icon: 'green_tick' },
                  ],
               },
               {
                  plan_identifier: 'premium',
                  plan_name: 'Musaffa Premium',
                  level: 2,
                  plan_description: 'Screener + Portfolio Basic',
                  all_identifiers: ['premium_monthly', 'premium_yearly'],
                  featured_items: [
                     {
                        name: 'Halal Status & Musaffa Star Rating',
                        icon: 'green_tick',
                     },
                     {
                        name: '150 Detailed Shariah Reports',
                        icon: 'green_tick',
                     },
                     {
                        name: '150 Shariah Compliance History',
                        icon: 'green_tick',
                     },
                     {
                        name: '150 Detailed ESG (ISRI) Reports',
                        icon: 'green_tick',
                     },
                     {
                        name: '10 Daily Stock Coverage Requests',
                        icon: 'green_tick',
                     },
                     { name: 'Advanced Compliance Alerts', icon: 'green_tick' },
                     {
                        name: 'Screener with advanced filters',
                        icon: 'green_tick',
                     },
                     {
                        name: '15 Watchlist (50 symbols per watchlist)',
                        icon: 'green_tick',
                     },
                     { name: 'Halal Stock Collections', icon: 'green_tick' },
                     { name: 'Super Investors Portfolio', icon: 'green_tick' },
                     {
                        name: 'Investment Checklist & Forecast',
                        icon: 'green_tick',
                     },
                     {
                        name: '3 Brokerage Connected Portfolios',
                        icon: 'green_tick',
                     },
                     { name: '5 Manual Portfolios', icon: 'green_tick' },
                     {
                        name: 'Portfolio Compliance Tracker & Analytics',
                        icon: 'green_tick',
                     },
                     {
                        name: 'Portfolio Purification Tracker',
                        icon: 'green_tick',
                     },
                     {
                        name: 'Brokerage Connected Trading (Beta)',
                        icon: 'green_tick',
                     },
                     {
                        name: 'Zakat Calculator with Live Portfolio Import',
                        icon: 'green_tick',
                     },
                     {
                        name: 'Intermediate courses and quizzes, advanced guides on halal investing and live webinars with experts  (coming soon)',
                        icon: 'green_tick',
                     },
                     {
                        name: 'Priority Support via Live Chat',
                        icon: 'green_tick',
                     },
                  ],
               },
               {
                  plan_identifier: 'premium_plus',
                  plan_name: 'Musaffa Premium Plus',
                  level: 3,
                  plan_description: 'Screener + Portfolio Advanced + Trading',
                  all_identifiers: [
                     'premium_plus_monthly',
                     'premium_plus_yearly',
                  ],
                  featured_items: [
                     {
                        name: 'Halal Status & Musaffa Star Rating',
                        icon: 'green_tick',
                     },
                     {
                        name: 'UNLIMITED Detailed Shariah Reports',
                        icon: 'green_tick',
                     },
                     {
                        name: 'UNLIMITED Shariah Compliance History',
                        icon: 'green_tick',
                     },
                     {
                        name: 'UNLIMITED Detailed ESG (ISRI) Reports',
                        icon: 'green_tick',
                     },
                     {
                        name: 'UNLIMITED Daily Stock Coverage Requests',
                        icon: 'green_tick',
                     },
                     {
                        name: 'Smart Compliance & Price Alerts',
                        icon: 'green_tick',
                     },
                     {
                        name: 'Screener with Advanced Filters',
                        icon: 'green_tick',
                     },
                     {
                        name: 'UNLIMITED Watchlists & Symbols',
                        icon: 'green_tick',
                     },
                     {
                        name: 'Advanced Halal Stock Collections',
                        icon: 'green_tick',
                     },
                     {
                        name: 'Advanced Super Investors Portfolio',
                        icon: 'green_tick',
                     },
                     {
                        name: 'Investment Checklist & Forecast',
                        icon: 'green_tick',
                     },
                     {
                        name: 'UNLIMITED Brokerage Connected Portfolios',
                        icon: 'green_tick',
                     },
                     {
                        name: 'UNLIMITED Manual Portfolios',
                        icon: 'green_tick',
                     },
                     {
                        name: 'Advanced Portfolio Compliance Tracker',
                        icon: 'green_tick',
                     },
                     {
                        name: 'Automated Portfolio Purification Tracker',
                        icon: 'green_tick',
                     },
                     {
                        name: 'Brokerage Connected Trading (Beta)',
                        icon: 'green_tick',
                     },
                     {
                        name: 'Zakat Calculator with Live Portfolio Import',
                        icon: 'green_tick',
                     },
                     {
                        name: 'Advanced certification courses, portfolio strategies and risk management, and exclusive masterclasses with experts (coming soon)',
                        icon: 'green_tick',
                     },
                     {
                        name: 'Premium Dedicated Priority Support via WhatsApp',
                        icon: 'green_tick',
                     },
                  ],
               },
            ],
            features: [
               {
                  feature_key: 'stock_halal_status',
                  feature_name: 'Stock Halal Status',
                  feature_group: 'Shariah Compliance',
                  plan_feature_config: [
                     {
                        plan_identifier: 'free',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'starter',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium_plus',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'professional',
                        access: true,
                        max_access: null,
                     },
                  ],
               },
               {
                  feature_key: 'etf_halal_status',
                  feature_name: 'ETF Halal Status',
                  feature_group: 'Shariah Compliance',
                  plan_feature_config: [
                     {
                        plan_identifier: 'free',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'starter',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium_plus',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'professional',
                        access: true,
                        max_access: null,
                     },
                  ],
               },
               {
                  feature_key: 'stock_halal_rating',
                  feature_name: 'Stock Halal Rating',
                  feature_group: 'Shariah Compliance',
                  plan_feature_config: [
                     {
                        plan_identifier: 'free',
                        access: false,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'starter',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium_plus',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'professional',
                        access: true,
                        max_access: null,
                     },
                  ],
               },
               {
                  feature_key: 'etf_halal_rating',
                  feature_name: 'ETF Halal Rating',
                  feature_group: 'Shariah Compliance',
                  plan_feature_config: [
                     {
                        plan_identifier: 'free',
                        access: false,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'starter',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium_plus',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'professional',
                        access: true,
                        max_access: null,
                     },
                  ],
               },
               {
                  feature_key: 'stock_compliance_report',
                  feature_name: 'Stock Compliance Report',
                  feature_group: 'Shariah Compliance',
                  plan_feature_config: [
                     {
                        plan_identifier: 'free',
                        access: false,
                        max_access: null,
                        access_duration: null,
                     },
                     {
                        plan_identifier: 'starter',
                        access: true,
                        max_access: 9999,
                        access_duration: 'monthly',
                     },
                     {
                        plan_identifier: 'premium',
                        access: true,
                        max_access: 9999,
                        access_duration: 'monthly',
                     },
                     {
                        plan_identifier: 'premium_plus',
                        access: true,
                        max_access: 9999,
                        access_duration: 'monthly',
                     },
                     {
                        plan_identifier: 'professional',
                        access: true,
                        max_access: 9999,
                        access_duration: 'monthly',
                     },
                  ],
               },
               {
                  feature_key: 'etf_compliance_report',
                  feature_name: 'Etf Compliance Report',
                  feature_group: 'Shariah Compliance',
                  plan_feature_config: [
                     {
                        plan_identifier: 'free',
                        access: false,
                        max_access: null,
                        access_duration: null,
                     },
                     {
                        plan_identifier: 'starter',
                        access: true,
                        max_access: 9999,
                        access_duration: 'monthly',
                     },
                     {
                        plan_identifier: 'premium',
                        access: true,
                        max_access: 9999,
                        access_duration: 'monthly',
                     },
                     {
                        plan_identifier: 'premium_plus',
                        access: true,
                        max_access: 9999,
                        access_duration: 'monthly',
                     },
                     {
                        plan_identifier: 'professional',
                        access: true,
                        max_access: 9999,
                        access_duration: 'monthly',
                     },
                  ],
               },
               {
                  feature_key: 'stock_coverage_request',
                  feature_name: 'Stock Coverage Request',
                  feature_group: 'Shariah Compliance',
                  plan_feature_config: [
                     {
                        plan_identifier: 'free',
                        access: false,
                        max_access: null,
                        access_duration: null,
                     },
                     {
                        plan_identifier: 'starter',
                        access: true,
                        max_access: 1,
                        access_duration: 'daily',
                     },
                     {
                        plan_identifier: 'premium',
                        access: true,
                        max_access: 10,
                        access_duration: 'daily',
                     },
                     {
                        plan_identifier: 'premium_plus',
                        access: true,
                        max_access: 20,
                        access_duration: 'daily',
                     },
                     {
                        plan_identifier: 'professional',
                        access: true,
                        max_access: 20,
                        access_duration: 'daily',
                     },
                  ],
               },
               {
                  feature_key: 'stock_compliance_update_request',
                  feature_name: 'Stock Compliance Update Request',
                  feature_group: 'Shariah Compliance',
                  plan_feature_config: [
                     {
                        plan_identifier: 'free',
                        access: false,
                        max_access: null,
                        access_duration: null,
                     },
                     {
                        plan_identifier: 'starter',
                        access: true,
                        max_access: 1,
                        access_duration: 'daily',
                     },
                     {
                        plan_identifier: 'premium',
                        access: true,
                        max_access: 10,
                        access_duration: 'daily',
                     },
                     {
                        plan_identifier: 'premium_plus',
                        access: true,
                        max_access: 20,
                        access_duration: 'daily',
                     },
                     {
                        plan_identifier: 'professional',
                        access: true,
                        max_access: 20,
                        access_duration: 'daily',
                     },
                  ],
               },
               {
                  feature_key: 'stock_shariah_compliance_history',
                  feature_name: 'Stock Shariah Compliance History',
                  feature_group: 'Shariah Compliance',
                  plan_feature_config: [
                     {
                        plan_identifier: 'free',
                        access: false,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'starter',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium_plus',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'professional',
                        access: true,
                        max_access: null,
                     },
                  ],
               },
               {
                  feature_key: 'multiple_shariah_standards',
                  feature_name: 'Multiple Shariah Standards',
                  feature_group: 'Shariah Compliance',
                  plan_feature_config: [
                     {
                        plan_identifier: 'free',
                        access: false,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'starter',
                        access: false,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium',
                        access: false,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium_plus',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'professional',
                        access: true,
                        max_access: null,
                     },
                  ],
               },
               {
                  feature_key: 'stock_details',
                  feature_name: 'Stock Details',
                  feature_group: 'Screener',
                  plan_feature_config: [
                     {
                        plan_identifier: 'free',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'starter',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium_plus',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'professional',
                        access: true,
                        max_access: null,
                     },
                  ],
               },
               {
                  feature_key: 'basic_filters',
                  feature_name: 'Basic Filters',
                  feature_group: 'Screener',
                  plan_feature_config: [
                     {
                        plan_identifier: 'free',
                        access: false,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'starter',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium_plus',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'professional',
                        access: true,
                        max_access: null,
                     },
                  ],
               },
               {
                  feature_key: 'advanced_filters',
                  feature_name: 'Advanced Filters',
                  feature_group: 'Screener',
                  plan_feature_config: [
                     {
                        plan_identifier: 'free',
                        access: false,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'starter',
                        access: false,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium_plus',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'professional',
                        access: true,
                        max_access: null,
                     },
                  ],
               },
               {
                  feature_key: 'watchlist',
                  feature_name: 'Watchlist',
                  feature_group: 'Screener',
                  plan_feature_config: [
                     { plan_identifier: 'free', access: true, max_access: 1 },
                     {
                        plan_identifier: 'starter',
                        access: true,
                        max_access: 5,
                     },
                     {
                        plan_identifier: 'premium',
                        access: true,
                        max_access: 9999,
                     },
                     {
                        plan_identifier: 'premium_plus',
                        access: true,
                        max_access: 9999,
                     },
                     {
                        plan_identifier: 'professional',
                        access: true,
                        max_access: 9999,
                     },
                  ],
               },
               {
                  feature_key: 'watchlist_items',
                  feature_name: 'Watchlist Items',
                  feature_group: 'Screener',
                  plan_feature_config: [
                     { plan_identifier: 'free', access: true, max_access: 100 },
                     {
                        plan_identifier: 'starter',
                        access: true,
                        max_access: 1000,
                     },
                     {
                        plan_identifier: 'premium',
                        access: true,
                        max_access: 1000,
                     },
                     {
                        plan_identifier: 'premium_plus',
                        access: true,
                        max_access: 1000,
                     },
                     {
                        plan_identifier: 'professional',
                        access: true,
                        max_access: 1000,
                     },
                  ],
               },
               {
                  feature_key: 'watchlist_compliance_alerts',
                  feature_name: 'Watchlist Compliance Alerts',
                  feature_group: 'Screener',
                  plan_feature_config: [
                     {
                        plan_identifier: 'free',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'starter',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium_plus',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'professional',
                        access: true,
                        max_access: null,
                     },
                  ],
               },
               {
                  feature_key: 'public_user_collections',
                  feature_name: 'Public User Collections',
                  feature_group: 'Screener',
                  plan_feature_config: [
                     {
                        plan_identifier: 'free',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'starter',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium_plus',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'professional',
                        access: true,
                        max_access: null,
                     },
                  ],
               },
               {
                  feature_key: 'public_user_collections_create',
                  feature_name: 'Public User Collections Create',
                  feature_group: 'Screener',
                  plan_feature_config: [
                     {
                        plan_identifier: 'free',
                        access: false,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'starter',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium_plus',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'professional',
                        access: true,
                        max_access: null,
                     },
                  ],
               },
               {
                  feature_key: 'trending_halal_stocks',
                  feature_name: 'Trending Halal Stocks',
                  feature_group: 'Screener',
                  plan_feature_config: [
                     {
                        plan_identifier: 'free',
                        access: false,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'starter',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium_plus',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'professional',
                        access: true,
                        max_access: null,
                     },
                  ],
               },
               {
                  feature_key: 'halal_stock_collections',
                  feature_name: 'Halal Stock Collections',
                  feature_group: 'Screener',
                  plan_feature_config: [
                     {
                        plan_identifier: 'free',
                        access: false,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'starter',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium_plus',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'professional',
                        access: true,
                        max_access: null,
                     },
                  ],
               },
               {
                  feature_key: 'super_investor_portfolio',
                  feature_name: 'Super Investor Portfolio',
                  feature_group: 'Screener',
                  plan_feature_config: [
                     {
                        plan_identifier: 'free',
                        access: false,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'starter',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium_plus',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'professional',
                        access: true,
                        max_access: null,
                     },
                  ],
               },
               {
                  feature_key: 'investment_checklist',
                  feature_name: 'Investment Checklist',
                  feature_group: 'Screener',
                  plan_feature_config: [
                     {
                        plan_identifier: 'free',
                        access: false,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'starter',
                        access: false,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium_plus',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'professional',
                        access: true,
                        max_access: null,
                     },
                  ],
               },
               {
                  feature_key: 'stock_forecast',
                  feature_name: 'Stock Forecast',
                  feature_group: 'Screener',
                  plan_feature_config: [
                     {
                        plan_identifier: 'free',
                        access: false,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'starter',
                        access: false,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium_plus',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'professional',
                        access: true,
                        max_access: null,
                     },
                  ],
               },
               {
                  feature_key: 'academy',
                  feature_name: 'Academy',
                  feature_group: 'Tools & Resources',
                  plan_feature_config: [
                     {
                        plan_identifier: 'free',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'starter',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium_plus',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'professional',
                        access: true,
                        max_access: null,
                     },
                  ],
               },
               {
                  feature_key: 'market_news',
                  feature_name: 'Market News',
                  feature_group: 'Tools & Resources',
                  plan_feature_config: [
                     {
                        plan_identifier: 'free',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'starter',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium_plus',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'professional',
                        access: true,
                        max_access: null,
                     },
                  ],
               },
               {
                  feature_key: 'zakat_calculator',
                  feature_name: 'Zakat Calculator',
                  feature_group: 'Tools & Resources',
                  plan_feature_config: [
                     {
                        plan_identifier: 'free',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'starter',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium_plus',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'professional',
                        access: true,
                        max_access: null,
                     },
                  ],
               },
               {
                  feature_key: 'manual_purification_calculator',
                  feature_name: 'Manual Purification Calculator',
                  feature_group: 'Tools & Resources',
                  plan_feature_config: [
                     { plan_identifier: 'free', access: true, max_access: 3 },
                     {
                        plan_identifier: 'starter',
                        access: true,
                        max_access: 9999,
                     },
                     {
                        plan_identifier: 'premium',
                        access: true,
                        max_access: 9999,
                     },
                     {
                        plan_identifier: 'premium_plus',
                        access: true,
                        max_access: 9999,
                     },
                     {
                        plan_identifier: 'professional',
                        access: true,
                        max_access: 9999,
                     },
                  ],
               },
               {
                  feature_key: 'screener_web_extension',
                  feature_name: 'Screener Web Extension',
                  feature_group: 'Tools & Resources',
                  plan_feature_config: [
                     {
                        plan_identifier: 'free',
                        access: false,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'starter',
                        access: false,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium_plus',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'professional',
                        access: true,
                        max_access: null,
                     },
                  ],
               },
               {
                  feature_key: 'musaffa_community',
                  feature_name: 'Musaffa Community',
                  feature_group: 'Tools & Resources',
                  plan_feature_config: [
                     {
                        plan_identifier: 'free',
                        access: false,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'starter',
                        access: false,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium_plus',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'professional',
                        access: true,
                        max_access: null,
                     },
                  ],
               },
               {
                  feature_key: 'manual_portfolio',
                  feature_name: 'Manual Portfolio',
                  feature_group: 'Portfolio',
                  plan_feature_config: [
                     { plan_identifier: 'free', access: false, max_access: 1 },
                     {
                        plan_identifier: 'starter',
                        access: true,
                        max_access: 9999,
                     },
                     {
                        plan_identifier: 'premium',
                        access: true,
                        max_access: 9999,
                     },
                     {
                        plan_identifier: 'premium_plus',
                        access: true,
                        max_access: 9999,
                     },
                     {
                        plan_identifier: 'professional',
                        access: true,
                        max_access: 9999,
                     },
                  ],
               },
               {
                  feature_key: 'brokerage_connected_portfolios',
                  feature_name: 'Brokerage Connected Portfolios',
                  feature_group: 'Portfolio',
                  plan_feature_config: [
                     { plan_identifier: 'free', access: false, max_access: 0 },
                     {
                        plan_identifier: 'starter',
                        access: true,
                        max_access: 3,
                     },
                     {
                        plan_identifier: 'premium',
                        access: true,
                        max_access: 20,
                     },
                     {
                        plan_identifier: 'premium_plus',
                        access: true,
                        max_access: 9999,
                     },
                     {
                        plan_identifier: 'professional',
                        access: true,
                        max_access: 9999,
                     },
                  ],
               },
               {
                  feature_key: 'portfolio_basic_analysis',
                  feature_name: 'Portfolio Basic Analysis',
                  feature_group: 'Portfolio',
                  plan_feature_config: [
                     {
                        plan_identifier: 'free',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'starter',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium_plus',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'professional',
                        access: true,
                        max_access: null,
                     },
                  ],
               },
               {
                  feature_key: 'portfolio_advanced_analysis',
                  feature_name: 'Portfolio Advanced Analysis',
                  feature_group: 'Portfolio',
                  plan_feature_config: [
                     {
                        plan_identifier: 'free',
                        access: false,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'starter',
                        access: false,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium',
                        access: false,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium_plus',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'professional',
                        access: true,
                        max_access: null,
                     },
                  ],
               },
               {
                  feature_key: 'portfolio_purification_tracker',
                  feature_name: 'Portfolio Purification Tracker',
                  feature_group: 'Portfolio',
                  plan_feature_config: [
                     {
                        plan_identifier: 'free',
                        access: false,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'starter',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium_plus',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'professional',
                        access: true,
                        max_access: null,
                     },
                  ],
               },
               {
                  feature_key: 'musaffa_trading',
                  feature_name: 'Musaffa Trading',
                  feature_group: 'Trading',
                  plan_feature_config: [
                     {
                        plan_identifier: 'free',
                        access: false,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'starter',
                        access: false,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'premium_plus',
                        access: true,
                        max_access: null,
                     },
                     {
                        plan_identifier: 'professional',
                        access: true,
                        max_access: null,
                     },
                  ],
               },
            ],
         },
      ),
      country_pricing_plans: JSON.stringify([
         {
            country_code: 'default',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 1.99,
            price_yearly: 9.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'af',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'al',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 17.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'dz',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'ao',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'ai',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'ag',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'ar',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'am',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 17.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'au',
            currency: 'AUD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 23.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'at',
            currency: 'EUR',
            currency_symbol: '€',
            price_monthly: 0,
            price_yearly: 17.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'az',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'bs',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 16.49,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'bh',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 10.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'bb',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 17.49,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'by',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 17.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'be',
            currency: 'EUR',
            currency_symbol: '€',
            price_monthly: 0,
            price_yearly: 17.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'bz',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'bj',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'bm',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'bt',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'bo',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'ba',
            currency: 'EUR',
            currency_symbol: '€',
            price_monthly: 0,
            price_yearly: 17.49,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'bw',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'br',
            currency: 'BRL',
            currency_symbol: 'R$',
            price_monthly: 0,
            price_yearly: 76.9,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'vg',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'bn',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'bg',
            currency: 'BGN',
            currency_symbol: 'лв',
            price_monthly: 0,
            price_yearly: 34.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'bf',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'kh',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 16.49,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'cm',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 17.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'ca',
            currency: 'CAD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 19.49,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'cv',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'ky',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'td',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'cl',
            currency: 'CLP',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 16500,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'cn',
            currency: 'CNY',
            currency_symbol: '¥',
            price_monthly: 0,
            price_yearly: 103,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'co',
            currency: 'COP',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 77900,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'cd',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'cd',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'cr',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'ci',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'hr',
            currency: 'HRK',
            currency_symbol: 'kn',
            price_monthly: 0,
            price_yearly: 139.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'cy',
            currency: 'EUR',
            currency_symbol: '€',
            price_monthly: 0,
            price_yearly: 17.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'cz',
            currency: 'CZK',
            currency_symbol: 'Kč',
            price_monthly: 0,
            price_yearly: 449,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'dk',
            currency: 'DKK',
            currency_symbol: 'kr',
            price_monthly: 0,
            price_yearly: 139,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'dm',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'do',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'ec',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'eg',
            currency: 'EGP',
            currency_symbol: '£',
            price_monthly: 0,
            price_yearly: 289.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'sv',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'ee',
            currency: 'EUR',
            currency_symbol: '€',
            price_monthly: 0,
            price_yearly: 17.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'sz',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'fj',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'fi',
            currency: 'EUR',
            currency_symbol: '€',
            price_monthly: 0,
            price_yearly: 18.49,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'fr',
            currency: 'EUR',
            currency_symbol: '€',
            price_monthly: 0,
            price_yearly: 17.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'ga',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'gm',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'ge',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 17.49,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'de',
            currency: 'EUR',
            currency_symbol: '€',
            price_monthly: 0,
            price_yearly: 17.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'gh',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 17.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'gr',
            currency: 'EUR',
            currency_symbol: '€',
            price_monthly: 0,
            price_yearly: 18.49,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'gd',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'gt',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'gw',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'gy',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'hn',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'hk',
            currency: 'HKD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 118,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'hu',
            currency: 'HUF',
            currency_symbol: 'Ft',
            price_monthly: 0,
            price_yearly: 7990,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'is',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 18.59,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'in',
            currency: 'INR',
            currency_symbol: '₹',
            price_monthly: 0,
            price_yearly: 799,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'id',
            currency: 'IDR',
            currency_symbol: 'Rp',
            price_monthly: 0,
            price_yearly: 169000,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'iq',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'ie',
            currency: 'EUR',
            currency_symbol: '€',
            price_monthly: 0,
            price_yearly: 18.49,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'il',
            currency: 'ILS',
            currency_symbol: '₪',
            price_monthly: 0,
            price_yearly: 49.9,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'it',
            currency: 'EUR',
            currency_symbol: '€',
            price_monthly: 0,
            price_yearly: 18.49,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'jm',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'jp',
            currency: 'JPY',
            currency_symbol: '¥',
            price_monthly: 0,
            price_yearly: 2000,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'jo',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'kz',
            currency: 'KZT',
            currency_symbol: '₸',
            price_monthly: 0,
            price_yearly: 7790,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'ke',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 17.49,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'kr',
            currency: 'KRW',
            currency_symbol: '₩',
            price_monthly: 0,
            price_yearly: 22000,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'xk',
            currency: 'EUR',
            currency_symbol: '€',
            price_monthly: 0,
            price_yearly: 17.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'kw',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 9.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'kg',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 16.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'la',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'lv',
            currency: 'EUR',
            currency_symbol: '€',
            price_monthly: 0,
            price_yearly: 17.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'lb',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'lr',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'ly',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'lt',
            currency: 'EUR',
            currency_symbol: '€',
            price_monthly: 0,
            price_yearly: 17.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'lu',
            currency: 'EUR',
            currency_symbol: '€',
            price_monthly: 0,
            price_yearly: 17.49,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'mo',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'mg',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'mw',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'my',
            currency: 'MYR',
            currency_symbol: 'RM',
            price_monthly: 0,
            price_yearly: 47.9,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'mv',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'ml',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'mt',
            currency: 'EUR',
            currency_symbol: '€',
            price_monthly: 0,
            price_yearly: 17.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'mr',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'mu',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'mx',
            currency: 'MXN',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 349,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'fm',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'md',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 17.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'mn',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'me',
            currency: 'EUR',
            currency_symbol: '€',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'ms',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'ma',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'mz',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'mm',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'na',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'nr',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'np',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'nl',
            currency: 'EUR',
            currency_symbol: '€',
            price_monthly: 0,
            price_yearly: 17.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'nz',
            currency: 'NZD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 27.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'ni',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'ne',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'ng',
            currency: 'NGN',
            currency_symbol: '₦',
            price_monthly: 0,
            price_yearly: 6900,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'mk',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'no',
            currency: 'NOK',
            currency_symbol: 'kr',
            price_monthly: 0,
            price_yearly: 179,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'om',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 10.49,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'pk',
            currency: 'PKR',
            currency_symbol: '₨',
            price_monthly: 0,
            price_yearly: 3300,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'pw',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'pa',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'pg',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'py',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'pe',
            currency: 'PEN',
            currency_symbol: 'S/.',
            price_monthly: 0,
            price_yearly: 57.9,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'ph',
            currency: 'PHP',
            currency_symbol: '₱',
            price_monthly: 0,
            price_yearly: 849,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'pl',
            currency: 'PLN',
            currency_symbol: 'zł',
            price_monthly: 0,
            price_yearly: 87.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'pt',
            currency: 'EUR',
            currency_symbol: '€',
            price_monthly: 0,
            price_yearly: 18.49,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'qa',
            currency: 'QAR',
            currency_symbol: '﷼',
            price_monthly: 0,
            price_yearly: 36.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'ro',
            currency: 'RON',
            currency_symbol: 'lei',
            price_monthly: 0,
            price_yearly: 87.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'ru',
            currency: 'RUB',
            currency_symbol: '₽',
            price_monthly: 0,
            price_yearly: 1090,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'rw',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'stp',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'sa',
            currency: 'SAR',
            currency_symbol: '﷼',
            price_monthly: 0,
            price_yearly: 42.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'sn',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'rs',
            currency: 'EUR',
            currency_symbol: '€',
            price_monthly: 0,
            price_yearly: 17.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'sc',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'sl',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'sg',
            currency: 'SGD',
            currency_symbol: 'S$',
            price_monthly: 0,
            price_yearly: 21.98,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'sk',
            currency: 'EUR',
            currency_symbol: '€',
            price_monthly: 0,
            price_yearly: 17.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'si',
            currency: 'EUR',
            currency_symbol: '€',
            price_monthly: 0,
            price_yearly: 18.49,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'sb',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'za',
            currency: 'ZAR',
            currency_symbol: 'R',
            price_monthly: 0,
            price_yearly: 289.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'es',
            currency: 'EUR',
            currency_symbol: '€',
            price_monthly: 0,
            price_yearly: 17.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'lk',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'kn',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'lc',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'vc',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'sr',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'se',
            currency: 'SEK',
            currency_symbol: 'kr',
            price_monthly: 0,
            price_yearly: 199,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'ch',
            currency: 'CHF',
            currency_symbol: 'CHF',
            price_monthly: 0,
            price_yearly: 15.5,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'tw',
            currency: 'TWD',
            currency_symbol: 'NT$',
            price_monthly: 0,
            price_yearly: 490,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'tj',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 16.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'tz',
            currency: 'TZS',
            currency_symbol: 'TSh',
            price_monthly: 0,
            price_yearly: 34900,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'th',
            currency: 'THB',
            currency_symbol: '฿',
            price_monthly: 0,
            price_yearly: 579,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'to',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'tt',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'tn',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'tr',
            currency: 'TRY',
            currency_symbol: '₺',
            price_monthly: 0,
            price_yearly: 349.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'tm',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'tc',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'ug',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 17.49,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'ua',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 17.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'ae',
            currency: 'AED',
            currency_symbol: 'د.إ',
            price_monthly: 0,
            price_yearly: 37.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'gb',
            currency: 'GBP',
            currency_symbol: '£',
            price_monthly: 0,
            price_yearly: 15.49,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'us',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'uy',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 15.49,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'uz',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 16.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'vu',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 've',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'vn',
            currency: 'VND',
            currency_symbol: '₫',
            price_monthly: 0,
            price_yearly: 349000,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'ye',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'zm',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 14.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
         {
            country_code: 'zw',
            currency: 'USD',
            currency_symbol: '$',
            price_monthly: 0,
            price_yearly: 17.99,
            primary_ribbon_text: 'Special Promotion',
            description: '3-months Free',
         },
      ]),
      purification_defaults: JSON.stringify({
         charity_items: [
            {
               title: 'Islamic Relief Worldwide',
               description:
                  "Islamic Relief is a faith-based humanitarian and development organization dedicated to saving and transforming the lives of the world's most vulnerable people. The organization was founded in 1984, and has worked in over 45 countries, assisting individuals, families, and communities through emergency response and development projects that have helped over 10 million people every year.",
               img: '/assets/images/islamic-relief-image.png',
               link: 'https://islamic-relief.org/',
            },
            {
               title: 'Muslim Global Relief',
               description:
                  "MGR start in remote villages around the world, empowering rural communities by providing basic necessities of life such as water, sanitation, education, livelihood, and socio-economic development. The organization has worked over 20 years in 40 countries. Recognized by The National British Muslim Awards as the UK's Best Muslim Charity.",
               img: 'https://i.imgur.com/8ufOAuY.png',
               link: 'https://www.muslimglobalrelief.org/',
            },
            {
               title: 'Muslim Aid',
               description:
                  "Muslim Aid is dedicated to overcoming social injustice in all of its forms, making global advocacy a central theme in all of our work. The organization collaborates with influential decision-makers and local communities to raise awareness about injustices that perpetuate extreme poverty, ranging from gender justice to access to education. Muslim Aid is one of only two Muslim organizations named to Savanta's Top 100 Most Loved Charity Brands 2020.",
               img: 'https://i.imgur.com/NZxDVPe.png',
               link: 'https://www.muslimaid.org/',
            },
         ],
         not_halal_item_text: {
            title: '{{name}} is Not Shariah Compliant.',
            description:
               'Purification applies only for Halal Stocks based upon their debt and not-halal income sources. Non Shariah Compliant stocks are not allowed to be invested in the first place.',
         },
         purification_methods: [
            {
               type: 'haram_purification',
               title: 'Not Halal Income Purification',
               description:
                  "Musaffa's Recommended Purification Methodology. This purification calculation considers all the below aspects: \n\nCONSIDERS non-dividend stocks. \nCONSIDERS the period of time shares are held. \nConsiders Interest Income. \nCONSIDERS earnings from Haram Revenue.",
            },
            {
               type: 'interest_purification',
               title: 'Interest Income Purification',
               description:
                  'This purification calculation considers the below aspects: \n\nCONSIDERS non-dividend stocks. \nCONSIDERS the period of time shares are held. \nCONSIDERS Interest Income. \nDOES NOT CONSIDER earnings from Haram Revenue.',
            },
            {
               type: 'dividend_purification',
               title: 'Dividend Purification',
               description:
                  'This purification calculation considers the below aspects: \n\nCONSIDERS earnings from Haram Revenue. \nDOES NOT CONSIDER non-dividend stocks. \nDOES NOT CONSIDER the period of time shares are held. \nDOES NOT CONSIDER Interest Income.',
            },
         ],
         not_purifiable_info:
            'As per the Shariah laws, it’s not permissible to invest in Non-compliant stocks. If a stock was previously Halal and it turned Not Halal / Doubtful, a grace period of 90 days can be applied, whereby the investors can continue to hold onto the shares. However, if after the next quarter financial statements, the shares are again non-compliant, then the shares must be disposed. Also, all the capital gains made during the “Non-Compliant” duration should also be purified.',
      }),
      marketing_banners: JSON.stringify([]),
      paywall_experiments: JSON.stringify({
         yearly_pricing_display_format: 'highlighted_yearly',
      }),
      musaffa_academy: JSON.stringify([
         {
            title: 'How to Increase Barakah in Your Wealth?',
            img: 'https://i.imgur.com/v2WadE4.jpg',
            link: 'https://academy.musaffa.com/how-to-increase-barakah-in-your-wealth/',
         },
         {
            title: '5 Tips on How to Invest in Stocks: A Guide for Muslims',
            img: 'https://i.imgur.com/8jFDdB9.jpg',
            link: 'https://academy.musaffa.com/5-tips-on-how-to-invest-in-stocks-a-guide-for-muslims/',
         },
         {
            title: 'Personal Finance – What You Need to Know About Investing in Halal Stocks',
            img: 'https://i.imgur.com/6MuNhRB.jpg',
            link: 'https://academy.musaffa.com/personal-finance-what-you-need-to-know-about-investing-in-halal-stocks/',
         },
         {
            title: '10 Common Stock Investing Mistakes to Avoid',
            img: 'https://i.imgur.com/0qv5IUD.jpg',
            link: 'https://academy.musaffa.com/10-common-stock-investing-mistakes-to-avoid/',
         },
         {
            title: 'Warren Buffet’s Rule No 1 in Stock Investing',
            img: 'https://i.imgur.com/kiygVsz.jpg',
            link: 'https://academy.musaffa.com/warren-buffets-rule-no-1-in-stock-investing/',
         },
      ]),
      feature_visibility_flags: JSON.stringify({
         stock_chart: 1,
         key_statistics: 1,
         news: 1,
         press_release: 1,
         analyst_rating: 1,
         investment_checklist: 1,
         forecast_overview: 1,
         related_stocks: 1,
         price_estimates: 1,
         revenue_estimates: 1,
         earnings_estimates: 1,
      }),
      free_buckets_collection: JSON.stringify([
         'CA2823651054',
         'CA30957Q1028',
         'US09060C4087',
         'KYG5223X1007',
         'US98873Q1004',
         'US15130G7097',
         'JE00B6T5S470',
         'GB00BN2CJ299',
         'GB00BYM8GJ06',
         'SG1X09940682',
         'SG1EB6000000',
         'SGXE91187273',
         'ID1000102007',
         'ID1000141807',
         'ID1000142508',
         'INE792J01015',
         'INE080A01014',
         'INE294Z01018',
         'MYL5157OO002',
         'MYQ0122OO000',
         'MYL7209OO009',
         'CA91825V4001',
         'CA88079F1071',
         'CA2823651054',
         'SA1510P1UMH1',
         'SA13LG50KBH9',
         'SA15M2B4LA13',
         'QA000A0M8VM3',
         'QA000A0NE8B4',
         'QA000A0YDSW8',
         'EGS38251C012',
         'EGS38391C016',
         'EGS360A1C011',
         'FR0010282822',
         'FR0010383877',
         'FR0011532225',
         'AEE01110S227',
         'AEA001201010',
         'AEE002901016',
         'ES0158480311',
         'ES0113312005',
         'ES0105621009',
         'NL0015000GX8',
         'GB00BMXH3352',
         'NL0010776944',
         'BH000A0J2481',
         'GB00BH452L44',
         'GB00BZ6C4F71',
         'AU000000BSE5',
         'US0787713009',
         'US2252651078',
         'KYG1329V2058',
         'DK0062498333',
         'DE000A1K03W5',
         'CA44415F1036',
         'MYL03048O005',
         'MYQ0070OO001',
         'MYQ0169OO001',
         'CA00433V1085',
         'CA30957Q1028',
         'US3811194030',
         'EGS65771C015',
         'EGS3C0O1C016',
         'EGS597R1C017',
         'SG1BE2000004',
         'SGXE73993458',
         'SGXE89830751',
         'ID1000059702',
         'ID1000112303',
         'ID1000071202',
         'INE579C01029',
         'INE579C01029',
         'INE861A01058',
         'FR00140043Y1',
         'FR0014005HJ9',
         'FR0011053636',
         'AER000101017',
         'AEA003201018',
         'AEI000301012',
         'SA0007879337',
         'SA15GHD4KS19',
         'SA139051UIH0',
         'ES0105687000',
         'ES0105509006',
         'ES0170884417',
         'QA000LB5T4U2',
         'QA0006929788',
         'QA000A0KD6K3',
         'NL0012817175',
         'NL0000334118',
         'NL0012866412',
         'MYL4464OO003',
         'MYL03033O007',
         'MYL03005O005',
         'SG1BE2000004',
         'SGXE78822223',
         'SG1AD9000001',
         'EGS65771C015',
         'EGS3C0O1C016',
         'EGS597R1C017',
         'FI0009800098',
         'GB00BYM8GJ06',
         'GB0030026057',
         'CA75339A1012',
         'CA4085491039',
         'CA57776F4050',
         'INE309M01012',
         'INE309M01012',
         'INE130L01014',
         'ID1000170400',
         'ID1000170905',
         'ID1000120603',
         'SA15D1I1VJH7',
         'SA1210540914',
         'SA15H194KT19',
         'US6475812060',
         'BRVIVTACNOR0',
         'US9043111072',
         'FR0011726835',
         'FR0004166197',
         'FR0000039091',
         'US86646P1030',
         'BMG637AM1024',
         'IE00BQPVQZ61',
         'NL0000440477',
         'QA000LB5T4U2',
         'ES0113312005',
         'AEG000501011',
         'MYL03013O009',
         'MYL03019O006',
         'MYL9601OO005',
         'ID1000160500',
         'ID1000142102',
         'ID1000148307',
         'US09060J1060',
         'US45790J8678',
         'JE00BQWMWC12',
         'SG0584008601',
         'SGXE38602509',
         'SG1BE2000004',
         'GB00B71N6K86',
         'GB00BN7ZCY67',
         'GB00BH452L44',
         'INE578L01014',
         'INE925Y01036',
         'INE706C01028',
         'QA000LB5T4U2',
         'QA0001200771',
         'QA0006929853',
         'US38268T1034',
         'US87918A1051',
         'AU000000IGO4',
         'CA9290821052',
         'CA18912C1023',
         'CA71677J1012',
         'SA15H134KV18',
         'SA15BG54KMH4',
         'SA153G80IF11',
         'ES0105509006',
         'ES0183746314',
         'ES0105634002',
         'AEG000501011',
         'AEE000501016',
         'AEA001401016',
         'FR0000039091',
         'NL0000226223',
         'FR0000121485',
         'GB00B10RZP78',
         'NL0012817175',
         'EGS360A1C011',
         'ID1000143209',
         'ID1000068703',
         'ID1000149305',
         'US88160R1014',
         'US0378331005',
         'US0079031078',
         'MYL9237OO008',
         'MYQ0138OO006',
         'MYQ0183OO002',
         'INE821I01022',
         'INE040H01021',
         'INE347G01014',
         'QA000A0NE8B4',
         'QA000A0M8VM3',
         'QA000B982PM1',
         'EGS30581C010',
         'EGS102S1C014',
         'EGS75011C014',
         'AEA003201018',
         'AEE01134E227',
         'AEE01110S227',
         'SG1T75931496',
         'BMG5958R1043',
         'SG1EB6000000',
         'SA13LG50KBH9',
         'SA14TG012N13',
         'SA0007879402',
         'ES0148396007',
         'ES0109067019',
         'ES0105621009',
         'DE0006231004',
         'GB00B1CKQD97',
         'DE0007164600',
         'AU00000088E2',
         'GB00B11DDB67',
         'GB00B0CGR828',
         'NL0010391025',
         'NL0012015705',
         'GB00B10RZP78',
         'NL0000226223',
         'FR0000120578',
         'FR0013481835',
         'CA44812T1021',
         'CA82509L1076',
         'CA5503721063',
         'BH000A0J2481',
         'US0378331005',
         'US88160R1014',
         'US67066G1040',
         'INE030A01027',
         'INE021A01026',
         'INE267A01025',
         'US62914V1061',
         'KYG5479M1050',
         'US65481N1000',
         'PK0064301010',
         'PK0048201013',
         'PK0079701014',
         'SA14TG012N13',
         'SA0007879113',
         'SA15M1HH2NH5',
         'CA82509L1076',
         'US5500211090',
         'CA13646K1084',
         'IE000S9YS762',
         'GB0009895292',
         'KY30744W1070',
         'TW0002330008',
         'TW0002330008',
         'KYG9491K1058',
         'AET000201011',
         'AET000301019',
         'AED000201015',
         'BD0645AGNI06 ',
         'BD0648ITCL08',
         'BD0644IOL003',
         'NL0010273215',
         'NL0009538784',
         'NL0015000TA9',
         'US7311052010',
         'US67421J1088',
         'US0528001094',
         'QA0006929853',
         'QA000A0KD6K3',
         'QA000A0M8VM3',
         'US7223041028',
         'IE00BTN1Y115',
         'IE00B4ND3602',
         'FR0000120321',
         'FR0000052292',
         'FR0000120578',
         'SGXZ34583559',
         'SG1T75931496',
         'US31788K1088',
         'MYL5183OO008',
         'MYL4707OO005',
         'MYL5258OO008',
         'US83417M1045',
         'US60741F1049',
         'IL0011595993',
         'ID1000095706',
         'ID1000142904',
         'ID1000129000',
         'DE0007164600',
         'DE000A1EWWW0',
         'DE0007164600',
         'DK0062498333',
         'DK0060534915',
         'US53632A3005',
         'BRVALEACNOR0',
         'BRVALEACNOR0',
         'BRVIVTACNOR0',
         'CH1134540470',
         'CH0012032048',
         'CH0114405324',
         'AU000000BHP4',
         'AU000000BHP4',
         'AU000000RIO1',
         'RU000A0DKVS5',
         'RU0009024277',
         'RU0009033591',
         'US82706C1080',
         'US0554742090',
         'BMG0171K1018',
         'NL0011585146',
         'NL0011585146',
         'IT0005452658',
         'US8808901081',
         'LU0974299876',
         'FR0014000MR3',
         'CLP8716Y1065',
         'US7475251036',
         'CL0000000100',
         'EGS60101C010',
         'EGS65541C012',
         'EGS729J1C018',
         'TRAKRDMR91G7',
         'PR30040P1032',
         'BH000A0KEZD7',
         'BH000A0J2481',
         'BH000A0CAQK6',
         'KR7207940008',
         'KR7006400006',
         'KR7373220003',
         'JE00B6T5S470',
         'US42207L1061',
         'CY0106002112',
         'ZAE000018123',
         'ZAE000259701',
         'ZAE000006896',
         'KYG237731073',
         'CNE100005XT6',
         'MHY6430L2029',
         'GRS260333000',
         'GRS518003009',
         'KYG872641009',
         'COT60PA00038',
         'EST01PA00013',
         'JE00BF0XVB15',
         'JE00B5TT1872',
         'JE00BNNMKT29',
         'JP3236200006',
         'JP3481800005',
         'JP3571400005',
         'ES0148396007',
         'ES0143416115',
         'ES0109067019',
         'US92826C8394',
         'US98980L1017',
         'US79466L3024',
         'MHY8565N3002',
         'BMG5269C1010',
         'BMG812761002',
         'US57667T1007',
         'BE0165385973',
         'BE0974320526',
         'NZXROE0001S2',
         'NZMELE0002S7',
         'NZFAPE0001S2',
         'NO0003054108',
         'NO0010196140',
         'FO0000000179',
         'KYG3323L1005',
         'THB056010002',
         'TH5882010009',
         'MX01OM000018',
         'GB00B2QPKJ12',
         'US88160R1014',
         'IM00BF0FMG91',
         'GG00B4WJSD17',
         'GB00B0CGR828',
         'GG00BBHXCL35',
         'FI0009013296',
         'FI0009013403',
         'FI0009014377',
         'ARLOMA300018',
         'PLLVTSF00010',
         'GB00B10RZP78',
         'US4581401001',
         'MT0002400118',
         'PHY7319E1039',
         'PHY6142T1052',
         'PHY2491W1046',
         'NGDANGCEM008',
         'FO0000000179',
         'FO0000000179',
      ]),
      portfolio_defaults: JSON.stringify({
         how_it_works: [
            'Select your broker and authenticate via the same',
            'Musaffa imports all your holdings',
            'Thats it! Musaffa does its magic and creates customised dashboard',
         ],

         purification_info:
            "Purification involves removing non-Shariah compliant income from mixed-activity companies to charity, as agreed upon by Muslim scholars. With this feature, make sure your investment income is fully Shariah-compliant by calculating the 'not halal' part of your income & then donate it to charities.",

         purification_states_info: {
            pending:
               'Purification is applicable once you sell the halal stocks. The list below displays purification amounts pending from your sales of halal stocks, applicable after sale.',
            purified:
               'Here you can view your Purified Transactions, which you would have donated to charities.',
            not_purifiable:
               'Purification is applicable once you sell the halal stocks. Investing in non-halal stocks, which are not purifiable, is not allowed.',
         },
      }),
      inapp_subscription_defaults: JSON.stringify({
         paywall_defaults: {
            first_time_intro: {
               title: 'Introducing Musaffa Premium',
               intro_description:
                  'We are introducing a suite of premium features to help Muslims around the globe take better Halal investment decisions.\nWe invite you to join as a Musaffa Premium Member ✨',
            },
            intro: {
               title: 'Upgrade to Premium',
               intro_description: '',
            },
            sub_title: 'Make Better Halal Investment Decisions',
            membership_benefits_url: '',
            disclaimer_text: '*Subscriptions renew automatically',
            country_disclaimer_label:
               'Premium features available for stocks of the following countries:',
            country_disclaimer_value:
               'US, UK, Canada, France, Saudi Arabia, India, Indonesia, Malaysia, Singapore. More countries would be added soon!',
            uncovered_country_message: {
               title: 'Premium features not available for {{COUNTRY}}',
               description_coverage_ui:
                  'Premium features listed above are not available for {{COUNTRY}}. Do you still want to proceed with the subscription?',
               description_feature_ui:
                  'Premium features listed above are not available for {{COUNTRY}}. Before proceeding please check the country wise coverage.',
            },
            feature_list: [
               {
                  feature_code: '',
                  icon: 'ic_premium_shariah.svg',
                  title: 'Shariah Compliance Detailed Report',
                  description:
                     'Get access to in-depth Shariah-compliance reports, including detailed business and financial screening results.',
                  video_url: '',
                  detailed_info_url: '',
               },
               {
                  feature_code: '',
                  icon: 'ic_premium_purification.svg',
                  title: 'Purification Calculator',
                  description:
                     "Make sure your investment income is fully Shariah-compliant by calculating the 'not halal' part of your income & then donate to charities.",
                  video_url: '',
                  detailed_info_url: '',
               },
               {
                  feature_code: '',
                  icon: 'ic_premium_forecast.svg',
                  title: 'Stock Forecast',
                  description:
                     'Gain access to the annual target price, revenue forecast, and earnings forecast.',
                  video_url: '',
                  detailed_info_url: '',
               },
               {
                  feature_code: '',
                  icon: 'ic_premium_investment.svg',
                  title: 'Investment Checklist',
                  description:
                     "Make smart investment decisions by examining companies' expected annual returns, risk levels, risk-adjusted returns, and dividend yields.",
                  video_url: '',
                  detailed_info_url: '',
               },
               {
                  feature_code: '',
                  icon: 'ic_premium_coverage.svg',
                  title: 'Stock Coverage Request',
                  description:
                     "Interested in a stock coverage which isn't available on Musaffa? You can now ask us to cover up to 3 companies per day.",
                  video_url: '',
                  detailed_info_url: '',
               },
               {
                  feature_code: '',
                  icon: 'ic_portfolio_mgmt.svg',
                  title: 'Portfolio Management (Coming Soon)',
                  description:
                     'Link your brokerage accounts to the Musaffa app and monitor Shariah compliance of your investments in real-time',
                  video_url: '',
                  detailed_info_url: '',
               },
            ],
            revenuecat_entitlement_code: 'premium',
            revenuecat_subscription_cta_android: ['P1Y', 'P1M'],
            country_wise_coverage: [
               {
                  country_code: 'US',
                  coverage: '6000+ Stocks, 3000 ETFs',
               },
               {
                  country_code: 'GB',
                  coverage: '600+ Stocks',
               },
               {
                  country_code: 'CA',
                  coverage: '550+ Stocks',
               },
               {
                  country_code: 'MY',
                  coverage: '750+ Stocks',
               },
               {
                  country_code: 'IN',
                  coverage: '2800+ Stocks',
               },
               {
                  country_code: 'ID',
                  coverage: '750+ Stocks',
               },
               {
                  country_code: 'AE',
                  coverage: '100+ Stocks',
               },
               {
                  country_code: 'SA',
                  coverage: '200+ Stocks',
               },
               {
                  country_code: 'QA',
                  coverage: '50+ Stocks',
               },
               {
                  country_code: 'SG',
                  coverage: '300+ Stocks',
               },
               {
                  country_code: 'FR',
                  coverage: '350+ Stocks',
               },
               {
                  country_code: 'EG',
                  coverage: '100+ Stocks',
               },
               {
                  country_code: 'NL',
                  coverage: '90+ Stocks',
               },
               {
                  country_code: 'ES',
                  coverage: '200+ Stocks',
               },
            ],
         },
         sample_feature_defaults: {
            stock_symbol: 'AAPL',
            stock_company_name: 'Apple',
            etf_symbol: 'SPY',
            etf_company_name: 'S&P 500',
            cta_text: 'Unlock All Premium Features',
            purification: {
               shares_quantity: 50,
               start_date: '2023-09-01',
               end_date: '2023-09-30',
            },
            copy_text: [
               {
                  feature: 'investment_checklist',
                  header: 'Sample: Investment Checklist',
                  title: 'Investment Checklist',
               },
               {
                  feature: 'stock_purification',
                  header: 'Sample: Stock Purification',
                  title: 'Stock Purification',
               },
               {
                  feature: 'compliance',
                  header: 'Sample: Shariah Compliance Report',
                  title: 'Shariah Compliance Report',
               },
               {
                  feature: 'stock_forecast',
                  header: 'Sample: Stock Forecast',
                  title: 'Stock Forecast',
               },
            ],
         },
         locked_feature_defaults: [
            {
               feature: 'compliance',
               title: 'Shariah Compliance Report',
               body: 'An extensive business and financial screening of the company which specifies why a stock is halal or haram!',
               sample_text: 'View Sample Shariah Compliance Report',
            },
            {
               feature: 'investment_checklist',
               title: 'Investment Checklist',
               body: 'A thorough checklist of Expected Returns, Risk Factor, Sharpe ratio & Dividend Yeild to help you take a better decision in investing!',
               sample_text: 'View Sample Investment Checklist',
            },
            {
               feature: 'stock_purification',
               title: 'Stock Purification',
               body: 'Income generated from selling shares of HALAL stocks also needs to be purified! Use our stock purification tool to calculate the amount you need to purify from your earnings',
               sample_text: 'View Sample Purification Calculation',
            },
            {
               feature: 'stock_forecast',
               title: 'Stock Forecast',
               body: 'View the estimated PRICE, REVENUE & EARNINGS forecast of the stock. Make informed decision about your investment growth before investing!',
               sample_text: 'View Sample Stock Forecast',
            },
         ],
         cancellation_reasons: [
            {
               key: 'too_expensive',
               display_value: 'Too expensive',
            },
            {
               key: 'not_enough_features',
               display_value: 'Not enough features',
            },
            {
               key: 'poor_user_experience',
               display_value: 'Poor user experience',
            },
            {
               key: 'inaccurate_data',
               display_value: 'Found the data as incomplete/inaccurate',
            },
            {
               key: 'temporary_need',
               display_value: 'The need was temporary',
            },
            {
               key: 'found_alternative',
               display_value: 'Found better alternative',
            },
            {
               key: 'other',
               display_value: 'Other (Please Specify)',
            },
         ],
      }),
      purification_articles: JSON.stringify({
         articles: [
            {
               title: 'What is Purification?',
               img: 'https://academy.musaffa.com/wp-content/uploads/2023/07/Find-Halal-Stocks-Using-Musaffa-Application.png',
               link: 'https://academy.musaffa.com/how-to-screen-halal-stocks-using-musaffa-app/',
               body: "In Islam, the purification of wealth is a crucial concept, ensuring that Muslims’ financial practices comply with their faith’s ethical standards. Purification in Islamic finance involves eliminating the portion of non-compliant income generated from Halal/Not-Halal stocks. \nMusaffa simplifies this process by calculating the purification amount based on your transactions, ensuring your investments remain pure. Musaffa’s Portfolio Purification Tracker is an innovative tool designed to ensure that Muslims' financial practices are not only compliant with their faith's ethical standards but also free from investments in non-Halal sources. This article goes deep into the essence of purification, the methodology Musaffa employs, the operational intricacies of its Portfolio Purification Tracker, and the steps to purify non-compliant stocks. \n### **Methodology** \nMusaffa's approach to purification encompasses a comprehensive Non-Halal Income Purification Methodology. We calculate the purification amount once the user sells his shares. \nThe calculation is based on the modified AAOFI purging methodology where we also consider the number of days the shares were held and historical shariah compliance of that stock during that period. \n- **Purification cycle:** Musaffa calculates the purification amount once the user sells the shares. \n- **Duration Inclusion:** \nMusaffa Purification takes into account the number of days the shares were held in the accounting period. \n- **Compliance History Inclusion:** \nMusaffa Purification also takes care of historical compliance of the stock and adds up any dividends received during the period when the stock was non-compliant. \n### **Purification Formula:** \nMusaffa uses the below formula to calculate the purification for each quarter/annual as per the availability of financial reports: \n\n`Not Halal Income / Shares Owned * Number of days owned / Number of days in the entire Accounting Period`",
            },
            {
               title: 'How does Musaffa Portfolio Purification Tracker work?',
               img: 'https://academy.musaffa.com/wp-content/uploads/2023/08/Check-Halal-Status-of-Your-Favorite-Stock.png',
               link: 'https://academy.musaffa.com/how-to-check-the-halal-status-of-the-stock/',
               body: "Musaffa’s Portfolio Purification Tracker stands out as a pivotal tool for Muslims aiming to adhere strictly to Shariah-compliant investing. \n### This flow of the feature is as follows: \n- **Linking Existing Brokerage Accounts:** \nUsers can connect their portfolios from supported brokerages, which are specifically selected for their capability to provide detailed transactions data necessary for accurate purification tracking. \n- **Transaction Data Analysis:** \nFor each sell transaction, Musaffa calculates the number of days the share was held and derives the purification amount using the AAOIFI purging method formula. \n- **Automatic Tracking and Purification:** \nThe tracker allows users to mark off purified amounts, keeping a diligent record of pending purifications. It also automatically updates purification calculations for new transactions executed through the linked brokerage. \n### **Calculation Methodology** \nMusaffa's approach to purification encompasses a comprehensive Non-Halal Income Purification Methodology. We calculate the purification amount once the user sells his shares. \nThe calculation is based on the modified AAOFI purging methodology where we also consider the number of days the shares were held and historical shariah compliance of that stock during that period. \n- **Purification cycle:** \nMusaffa calculates the purification amount once the user sells the shares. \n- **Duration Inclusion:** \nMusaffa Purification takes into account the number of days the shares were held in the accounting period. \n- **Compliance History Inclusion:** \nMusaffa Purification also takes care of historical compliance of the stock and adds up any dividends received during the period when the stock was non-compliant. \n### **Purification Formula:** \nMusaffa uses the below formula to calculate the purification for each quarter/annual as per the availability of financial reports: \n\n`Not Halal Income / Shares Owned * Number of days owned / Number of days in the entire Accounting Period`",
            },
            {
               title: 'How to purify non-compliant stocks?',
               img: 'https://academy.musaffa.com/wp-content/uploads/2023/08/Musaffa-Investment-Checklist-1.png',
               link: 'https://academy.musaffa.com/how-to-make-better-investment-decisions-using-the-investment-checklist/',
               body: "Purifying non-compliant stocks is a critical component of maintaining a Halal investment portfolio. Musaffa facilitates this process by: \n1. **Linking Your Brokerage Account:** \nImport your holdings and transaction data by connecting your brokerage account, which enables Musaffa to accurately calculate purification amounts. \n2. **Grace Period:** \nIf a stock turns non-compliant, Shariah advisors have given a grace period of 90 days - up until the company's next quarterly financial reports are published and shariah compliance is re-analysed. During this grace period, you can still continue to hold your shares. \n3. **Decision Time:** \nPost the 90-day period, if the stock remains non-compliant, you are required to sell your shares. The proceeds gained during the non-compliant period should be donated to charity, ensuring that your wealth remains purified. \n4. **Reassessment and Compliance:** \nShould the stock return to a compliant status in subsequent assessments, selling it isn’t necessary. However, any dividends received during its non-compliant phase should be donated fully to charity. \nIf a stock remains non-compliant in the subsequent quarter, investors are required to divest within 90 days. Musaffa aids in identifying these stocks and calculating the necessary purification for any gains or dividends received during the non-compliant period. \n5. **Automated Purification Calculations:** \nFor stocks that have been non-compliant for any period during your ownership, Musaffa automatically calculates the amount to be purified, ensuring your portfolio remains in strict adherence to Islamic finance principles.\nThe grace period provided allows investors to make informed decisions based on the stock’s compliance status, ensuring their investments are both profitable and pure.",
            },
         ],
         how_it_works: [
            'Select your broker and authenticate via the same',
            'Musaffa imports your transactions data',
            'Thats it! Musaffa calculates your purification amount based on your holdings & company’s recent annual financial reports.',
         ],
         purification_status_reason: [
            {
               key: 'NOT_COVERED',
               value: "We couldn't calculate the purification amount for this Sell transaction since the stock is not yet covered by Musaffa. As a premium user, you can request for the coverage of this stock from the stock details page and try calculating the purification amount once again.",
            },
            {
               key: 'NO_DATA',
               value: "We couldn't calculate the purification amount for this Sell transaction since the stock's BUY and SELL date is before the period for which the financial screeening data is not avaialble with Musaffa.",
            },
            {
               key: 'PARTIAL_DATA',
               value: 'The purification amount calculated is for the period {{PURIFIED_FROM}} to {{PURIFIED_TO}} because the business screening reports before that period are not available with Musaffa.',
            },
         ],
      }),
      portfolio_articles: JSON.stringify({
         how_it_works: [
            'Select your broker and authenticate via the same',
            'Musaffa imports all your holdings',
            'Thats it! Musaffa does its magic and creates customised dashboard',
         ],
         purification_info:
            "Purification involves removing non-Shariah compliant income from mixed-activity companies to charity, as agreed upon by Muslim scholars. With this feature, make sure your investment income is fully Shariah-compliant by calculating the 'not halal' part of your income & then donate it to charities.",
         purification_states_info: {
            pending:
               'Purification is applicable once you sell the halal stocks. The list below displays purification amounts pending from your sales of halal stocks, applicable after sale.',
            purified:
               'Here you can view your Purified Transactions, which you would have donated to charities.',
            not_purifiable:
               'Purification is applicable once you sell the halal stocks. Investing in non-halal stocks, which are not purifiable, is not allowed.',
         },
         articles: [
            {
               title: "How does Musaffa's Portfolio Compliance Tracker work?",
               img: 'https://academy.musaffa.com/wp-content/uploads/2023/07/Find-Halal-Stocks-Using-Musaffa-Application.png',
               link: 'https://academy.musaffa.com/how-to-screen-halal-stocks-using-musaffa-app/',
               body: 'As Muslim investors, we would always want to keep a track of the compliance statuses of our holdings. Musaffa’s Portfolio Compliance Tracker feature helps exactly in doing so. \nMusaffa’s Portfolio Compliance Tracker is a  tool that watches over your investments and tells you if a stock in your portfolio turns non-compliant suddenly. Moreover it gives you an overview of what percentage of your entire portfolio is compliant and what’s non compliant. \nHere’s a closer look at how it works and what actions to take if your investments turn non-compliant.\nThe Portfolio Compliance Tracker offers a user-friendly interface that seamlessly integrates with your existing brokerage account. You can view the supported brokerages before beginning to link one. If your brokerage isn’t directly supported, Musaffa allows for manual addition of holdings, ensuring no investor is left behind. \n\n**Here’s the process:** \n- Link your brokerage account from the list of available integrations provided by Musaffa, or if your brokerage integration is unavailable, you can manually add your holdings. \n- This secure connection ensures that your investment data is accurately imported into Musaffa’s system. \n- Once linked, Musaffa diligently monitors your entire portfolio for Shariah compliance, providing a comprehensive view of your compliance. Track your portfolio’s compliance with ease \n- Receive timely notifications if the compliance status of any stock within your portfolio changes. The tracker is designed to alert you promptly, enabling you to make informed decisions quickly.',
            },
            {
               title: 'What to do when a stock in your portfolio turns non-compliant?',
               img: 'https://academy.musaffa.com/wp-content/uploads/2023/08/Check-Halal-Status-of-Your-Favorite-Stock.png',
               link: 'https://academy.musaffa.com/how-to-check-the-halal-status-of-the-stock/',
               body: "Discovering that a stock is no longer compliant can be concerning. However, Musaffa provides clear guidelines on how to proceed, as advised by our Shariah advisors Mufti Faraz Adam and Shaikh Dr. Aznan Hasan: \n1. **Monitor and Act:** \nKeep a close eye on the compliance status of your stocks through Musaffa. Link your existing brokerage accounts and let Musaffa monitor your holdings and notify you about the compliance changes. The platform’s notifications are crucial for timely responses to any changes. \n2. **Grace Period:** \nIf a stock turns non-compliant, Shariah advisors have given a grace period of 90 days - up until the company's next quarterly financial reports are published and shariah compliance is re-analysed. During this grace period, you can still continue to hold your shares. \n3. **Decision Time:** \nPost the 90-day period, if the stock remains non-compliant, you are required to sell your shares. The proceeds gained during the non-compliant period should be donated to charity, ensuring that your wealth remains purified.\n4. **Reassessment and Compliance:** \nShould the stock return to a compliant status in subsequent assessments, selling it isn’t necessary. However, any dividends received during its non-compliant phase should be donated fully to charity. \n\nMusaffa’s Portfolio Compliance & Purification Tracker features makes sure you can invest without worrying about breaking Islamic rules. It watches over your investments, alerts you to changes, and guides you on how to keep your earnings pure. With Musaffa, you can focus on growing your investments in a way that matches your values.",
            },
         ],
      }),
      crowdfunding_defaults: JSON.stringify({
         title: 'Invest in Musaffa and join our vision!',
         link: 'https://invest.musaffa.com?utm_source=musaffa_mobile_app',
         preseed_defaults: {
            title: 'Pre-seed',
            value: '$2.6M',
            subtitle: 'Raised from\nAccredited Investors',
            progress_percent: 100,
         },
      }),
   },
};
